module.exports = __webpack_public_path__ + "img/BS08.ca85151d.svg";